import { useEffect } from 'react';

const useCounter = (selector, options = {}) => {
  useEffect(() => {
    const elements = document.querySelectorAll(selector);
    
    const animateValue = (element, start, end, duration) => {
      let startTimestamp = null;
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const current = Math.floor(progress * (end - start) + start);
        element.textContent = current.toLocaleString();
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target;
          const to = parseInt(element.dataset.to, 10);
          const speed = parseInt(element.dataset.speed, 10);
          animateValue(element, 0, to, speed);
          observer.unobserve(element);
        }
      });
    }, options);

    elements.forEach(element => observer.observe(element));

    return () => observer.disconnect();
  }, [selector]);
};

export default useCounter;
